// Simple reactive store for snackbar
import Vue from 'vue';

export const snackbarService = Vue.observable({
  visible: false,
  text: '',
  color: '',
  timeout: 6000,
  
  show(text, color = 'info', timeout = 6000) {
    this.text = text;
    this.color = color;
    this.timeout = timeout;
    this.visible = true;
  },
  
  success(text) {
    this.show(text, 'success');
  },
  
  error(text) {
    this.show(text, 'error');
  },
  
  info(text) {
    this.show(text, 'info');
  },
  
  hide() {
    this.visible = false;
  }
});
